/**
 * Created by trump on 16/8/24.
 */
import "../../../_core/libRequirePathHelper";
require('../../../../bower_components/animate.css');
import {WOW} from "wowjs";
import _ from "lodash";
import $ from "jquery";


var lib = {
    initAll() {
        _.forEach(mf_app.allPlugins, plugin=> this.init(plugin));
        new WOW().init();
    },
    init(plugin) {
        var $el = $(`#plugin-${plugin.id}`);
        if (plugin.data && plugin.data.animate && plugin.data.animate.isEnabled !== false) {
            var animateConfig = plugin.data.animate;
            var animateAttr = {};
            
            if(animateConfig.duration) {
                animateAttr['data-wow-duration'] = `${animateConfig.duration}s`;
                animateAttr['data-wow-delay'] = `${animateConfig.delay}s`;
            }
            $el.attr(animateAttr);
            $el.addClass(`wow ${animateConfig.name}`);
        } else {
            $el.removeClass('wow');
        }
    },
    destroy(plugin) {
    }
};

$(()=>{
    mf_app.addLib('*', lib);
});






// WEBPACK FOOTER //
// ./_share.pluginLibs/libs/animate/index.js